export interface SaphirFunction {
    name: string,
    active: boolean,
}

export enum SaphirFunctionNames {
    TerminalDisplay = 'GESTION_BORNES',
}
